"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Enum = _interopRequireDefault(require("../codec/Enum"));

// Copyright 2017-2019 @polkadot/types authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.

/**
 * @name RewardDestination
 * @description
 * A destination account for payment
 */
class RewardDestination extends _Enum.default {
  constructor(value) {
    super([// Pay into the stash account, increasing the amount at stake accordingly.
    'Staked', // Pay into the stash account, not increasing the amount at stake.
    'Stash', // Pay into the controller account.
    'Controller'], value);
  }

}

exports.default = RewardDestination;